export default {
  path: '/kanban-boards/:id',
  component: () => import(/* webpackChunkName: "kanban-board" */ './KanbanBoard'),
  props: true,
  meta: {
    requiresAuth: true
  }
}
